import React from "react";
import PortfolioGallery from "../components/PortfolioGallery";
import '../css/portfolio.css';

const portfolio = () => {
  return (
    <>
      <PortfolioGallery />
    </>
  );
};

export default portfolio;
